export default __webpack_public_path__ + "static/media/kid-11.4920ed2a.jpg";